import { checkEmptyVal } from "../../utils/common";
import "./ClientConnectLoader.css";

// Client <-> AssetsWatch connecting card.
// ClientAuth shows client -> AssetsWatch; logout shows it reversed (AssetsWatch -> client)
// as a full-screen overlay while the browser leaves for the client site.
const ClientConnectLoader = ({
  clientName,
  clientLogo,
  title,
  copy,
  reverse = false,
  overlay = false,
}) => {
  const clientLogoEl = (
    <div className="client-auth-logo-wrap">
      {!checkEmptyVal(clientLogo) ? (
        <img
          className="client-auth-logo"
          src={clientLogo}
          alt={clientName || "Client"}
        />
      ) : (
        <span className="client-auth-logo-fallback" aria-label="Client">
          <i className="fa fa-building"></i>
        </span>
      )}
    </div>
  );

  const awLogoEl = (
    <div className="client-auth-logo-wrap">
      <img
        className="client-auth-logo client-auth-assetswatch-logo"
        src="/assets/images/logo-sm.png"
        alt="AssetsWatch"
      />
    </div>
  );

  const Wrapper = overlay ? "div" : "main";

  return (
    <Wrapper
      className={`client-auth-page${overlay ? " client-auth-overlay" : ""}`}
    >
      <section className="client-auth-card box-shadow" aria-live="polite">
        <div className="client-auth-brand-flow">
          {reverse ? awLogoEl : clientLogoEl}

          <div className="client-auth-connector" aria-hidden="true">
            <span className="client-auth-connector-track"></span>
            <span className="client-auth-connector-dot"></span>
            <div className="client-auth-lock">
              <i className="fas fa-lock"></i>
            </div>
          </div>

          {reverse ? clientLogoEl : awLogoEl}
        </div>

        <h1 className="client-auth-title">{title}</h1>
        <p className="client-auth-copy">{copy}</p>

        <div className="client-auth-progress" aria-hidden="true">
          <span></span>
        </div>
      </section>
    </Wrapper>
  );
};

export default ClientConnectLoader;
